export default {"src":"/_next/static/media/location-pin-orange.6121aa85.svg","height":18,"width":16};